import React, { Component } from 'react';
import { Table, Button, Input } from 'antd';
import RegisterLeave from './RegisterLeave';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class Filter extends Component {
    constructor(props) {
        super(props);
        const { params } = this.props;
        this.state = {
            searchParams: { ...params },
        }
    }

    componentDidMount() {
        this.search();
    }

    search = () => {
        const {
            searchParams,
        } = this.state;
        this.props.search({ ...searchParams });
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    render() {
        const {
            searchParams: {
                employeeCode,
                userCompellation,
            }
        } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class Leave extends Component {
    state = {
        data: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        role: {},
    }

    componentDidMount() {
        const { curRole } = sessionStorage;
        const role = {
            isVP: curRole == 'VP',
            isFIN: curRole == 'FIN',
            isHRRC: curRole == 'HRRC',
        };
        this.setState({ role });
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserLeaveList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            subList: {},
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    getDateRender = text => text ? text.slice(0, 10) : ''

    getColumns = () => {
        const { role: { isVP, isFIN, isHRRC } } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            sorter: true,
            fixed: 'left',
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 180,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 60,
        }, {
            title: '离职时间',
            dataIndex: 'leftTime',
            key: 'leftTime',
            width: 80,
            render: this.getDateRender,
        }, {
            title: '离职去向',
            dataIndex: 'firstLeaveToName',
            key: 'firstLeaveToName',
            width: 100,
            render: (text, record) => {
                const { secondLeaveToName, leaveToComments } = record;
                if (!text) {
                    return '';
                } else if (text == 'SMO') {
                    return `${text}${secondLeaveToName ? `(${secondLeaveToName}${leaveToComments ? `-${leaveToComments}` : ''})` : ''}`;
                } else {
                    return `${text}${leaveToComments ? `(${leaveToComments})` : ''}`;
                }
            }
        }, {
            title: '去向职位',
            dataIndex: 'leavePositionName',
            key: 'leavePositionName',
            width: 80,
            render: (text, record) => {
                const { positionComments } = record;
                return text ? `${text}${positionComments ? `(${positionComments})` : ''}` : '';
            }
        }, {
            title: '离职原因',
            dataIndex: 'firstReasonName',
            key: 'firstReasonName',
            width: 120,
            render: (text, record) => {
                const { secondReasonName } = record;
                return text ? `${text}${secondReasonName ? `(${secondReasonName})` : ''}` : '';
            }
        }];
        if (!(isVP || isFIN || isHRRC)) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 100,
                fixed: 'right',
                render: (text, record) => {
                    return <a onClick={() => this.registerLeave(record)}>登记离职信息</a>
                }
            })
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    registerLeave = (params) => {
        this.registerLeaveRef.show({...params});
    }

    render() {
        const { params } = this.props;
        const { loading, pagination } = this.state;
        return (
            <div>
                <Filter
                    params={params}
                    search={this.search}
                    export={this.export}
                />
                <Table
                    loading={loading}
                    scroll={{ x: 1160 }}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.userId}
                    onChange={this.handleTableChange}
                />
                <RegisterLeave ref={el => this.registerLeaveRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default Leave;


// WEBPACK FOOTER //
// ./src/components/user/userInfo/Leave.js